import type { ChannelKind, OpenUrlWithKind, Status } from '@api/generated/models';
import { FlexibleBaseSpecification, FlexibleModelBase } from './flexible_base';

interface Icon {
	origin: string;
	type: 'svgUrl' | 'pngUrl' | 'local';
}

export interface AccessFlow {
	triage: {
		isOpen: boolean;
		text: string;
		status: Status;
	};
	messaging: {
		isOpen: boolean;
		text: string;
		status: Status;
	};
}

export interface FlexibleActionCardSpecification extends FlexibleBaseSpecification {
	id: number;
	title: string;
	url: string;
	requiresAuthentication: boolean;
	openAnotherApp: boolean;
	hasBrandedNavbar: boolean;
	icon: Icon | null;
	subtitle: string;
	openUrlWith: OpenUrlWithKind;
	accessFlow?: AccessFlow;
	channel: ChannelKind | null;
}

/**
 * NOTE: ActionCard is not a part of the backend spec. We're intentionally
 * defining it on the frontend.
 */
export class FlexibleActionCardModel extends FlexibleModelBase {
	public readonly title: string;
	public readonly url: string;
	public readonly requiresAuthentication: boolean;
	public readonly openAnotherApp: boolean;
	public readonly hasBrandedNavbar: boolean;
	public readonly icon: Icon | null;
	public readonly subtitle: string;
	public readonly openUrlWith: OpenUrlWithKind;
	public readonly accessFlow?: AccessFlow;
	public readonly channel: ChannelKind | null;

	constructor(spec: FlexibleActionCardSpecification) {
		super(spec);

		this.title = spec.title;
		this.url = spec.url;
		this.requiresAuthentication = spec.requiresAuthentication;
		this.openAnotherApp = spec.openAnotherApp;
		this.hasBrandedNavbar = spec.hasBrandedNavbar;
		this.icon = spec.icon;
		this.subtitle = spec.subtitle;
		this.openUrlWith = spec.openUrlWith;
		this.accessFlow = spec.accessFlow;
		this.channel = spec.channel;
	}
}
